import { useCallback, useEffect, useState } from "react";

export type ThemeMode = "light" | "dark";

const STORAGE_KEY = "forge-theme";

function getInitialTheme(): ThemeMode {
	const stored = localStorage.getItem(STORAGE_KEY);
	if (stored === "light" || stored === "dark") return stored;
	return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function applyTheme(theme: ThemeMode) {
	document.documentElement.dataset.theme = theme;
}

export function useTheme() {
	const [theme, setTheme] = useState<ThemeMode>(getInitialTheme);

	useEffect(() => {
		applyTheme(theme);
		localStorage.setItem(STORAGE_KEY, theme);
	}, [theme]);

	const toggle = useCallback(() => {
		setTheme((t) => (t === "light" ? "dark" : "light"));
	}, []);

	return { theme, toggle } as const;
}
